/**
 * !!
 * Use 'npm run build' to build js files after new additions
 * - Remember to 'theme watch' while running above build command, so it uploads new files
 */

/**
 * Set CSS variables
 */


function updateVariables() {
	var header = document.querySelector('#HeaderWrapper')
	if ( header ) document.documentElement.style.setProperty('--headerHeight', header.offsetHeight + 'px')

	var scrollSidebar = document.querySelector('.scroll__aside')
	if ( scrollSidebar ) document.documentElement.style.setProperty('--scrollSidebar', scrollSidebar.offsetHeight + 'px')
}

function isIOS() {
  if (/iPad|iPhone|iPod/.test(navigator.platform)) {
    return true;
  } else {
    return navigator.maxTouchPoints &&
      navigator.maxTouchPoints > 2 &&
      /MacIntel/.test(navigator.platform);
  }
}

document.addEventListener('DOMContentLoaded', function() {
	updateVariables();

	window.addEventListener('resize', function() {
		updateVariables();
	});

  if (isIOS()) {
    document.documentElement.classList.add('is-ios');
  }

	// /**
	//  * Sticky product form
	//  */

	// var productForm = document.querySelector('[data-product-form]')
	// var placeholder = false
	// var footer = document.querySelector('#shopify-section-footer');

	// function setStickyClass() {
	// 	var bottom = window.scrollY + window.innerHeight;
	// 	var formBottom = productForm.offsetTop + productForm.offsetHeight + 1 // Border

	// 	if ( bottom > formBottom ) productForm.classList.add('no-sticky')
	// 	else productForm.classList.remove('no-sticky')

	// 	var uspHeight = getComputedStyle(document.documentElement).getPropertyValue('--uspbar');

	// 	if ( window.scrollY > (productForm.offsetTop - parseInt(uspHeight)) && (window.scrollY + window.innerHeight) < footer.offsetTop ) {

	// 		if ( !placeholder ) {
	// 			placeholder = document.createElement('div')
	// 			placeholder.style.height = productForm.offsetHeight + 'px';
	// 			productForm.insertAdjacentElement('beforebegin', placeholder)
	// 		}

	// 		productForm.classList.add('is-fixed')
	// 	} else {
	// 		productForm.classList.remove('is-fixed')

	// 		if ( placeholder ) {
	// 			placeholder.remove();
	// 			placeholder = false
	// 		}
	// 	}
	// }

	// if ( productForm ) {
	// 	setStickyClass();
	// 	window.addEventListener('resize', setStickyClass)
	// 	window.addEventListener('scroll', setStickyClass)
	// }

})


/**
 * Get cart data
 * @param {function} callback
 * @returns callback with data accessible
 */

function getCart( callback ) {
	return fetch(window.theme.routes.cart, {
		method: 'GET',
		credentials: 'include',
		headers: {
			'Content-Type': 'application/json',
			'X-Requested-With': 'XMLHttpRequest'
		}
	}).then(function(response) {
		return response.json()
	}) .then(function(data) {
		callback(data)
	})
}

function updateCartCount() {
	var counts = document.querySelectorAll('[data-cart-count]')

	getCart(function(data) {
		var itemCount = data.item_count

		counts.forEach(function(count) {
			count.hidden = itemCount === 0

			if (count.innerHTML.includes('(') && count.innerHTML.includes(')')) {
				count.innerHTML = `(${itemCount})`;
			} else {
				count.innerHTML = itemCount;
			}
		})
	})
}

document.addEventListener('ajaxProduct:added', updateCartCount);
document.addEventListener('cart:updated', updateCartCount);
// document.addEventListener('cart:quantity', function(event) {
// 	var count = document.querySelector('[data-cart-count]')
// 	var itemCount = event.detail[1]

// 	count.innerHTML = itemCount
// });

/**
 * Terms popup
 */

var termsPopup = document.querySelector('[data-terms-popup]')
var form = document.querySelector('#CartDrawerForm')
var submit = document.querySelector('button[type="submit"][name="checkout"]');

function getCookie(name) {
	var v = document.cookie.match('(^|;) ?' + name + '=([^;]*)(;|$)');
	return v ? v[2] : null;
}

if ( submit != null ) {
	var terms = form.querySelector('#CartTermsDrawer');

	submit.addEventListener('click', function(e) {
		if (!terms.checked) {
			e.preventDefault();

			if (getCookie('cart-upsell')) {
				openPopup();
			}
		}
	})

	document.addEventListener('terms:trigger', () => {
		openPopup();
	}, { once: true });
}

function openPopup() {
	termsPopup.classList.add('is-open')
	termsPopup.setAttribute('aria-hidden', false)
}

function closePopup() {
	termsPopup.classList.remove('is-open')
	termsPopup.setAttribute('aria-hidden', true)
}

if ( termsPopup != null ) {
  	var accept = termsPopup.querySelector('[data-accept]')
	var close = termsPopup.querySelectorAll('[data-close]')

	close.forEach(function(item) {
		item.addEventListener('click', closePopup)
	})

	accept.addEventListener('click', function(e) {
		closePopup()
		var terms = form.querySelector('#CartTermsDrawer')
		terms.checked = true

		var submit = form.querySelector('button[type="submit"][name="checkout"]')
		submit.click();
	})
}



/**
 * Navigation
 */

function findMatch(needle, haystack, attribute = 'group') {
  var match = Array.from(haystack).filter(function(item) {
    return item.dataset[attribute] === needle;
  });

  if (match) return match;
  return false;
}

var submenus = document.querySelectorAll('[data-nav-submenu]');
submenus.forEach(function(submenu) {
  var items = submenu.querySelectorAll('[data-item]');
  var subitems = submenu.querySelectorAll('[data-subitem]');
  var groups = submenu.querySelectorAll('[data-group]');
  var ctas = submenu.querySelectorAll('[data-cta]');

	function setVisibility(
    item,
    items,
    array,
    hideNoMatch = false,
    needle = 'item',
    hayStackNeedle = 'group'
  ) {
		var groupMatch = findMatch(item.dataset[needle], array, hayStackNeedle);

		items.forEach(function(item) {
			item.parentNode.classList.remove('is-active')
		});

		item.parentNode.classList.add('is-active');

		if (groupMatch.length) {
			array.forEach(function(group) {
				group.classList.add('invisible')
			});

			groupMatch.forEach(function(group) {
				group.classList.remove('invisible');
			});
		} else if (hideNoMatch) {
      array.forEach(function(group) {
				group.classList.add('invisible')
			});
    }
	}

  items.forEach(function(item) {
    item.addEventListener('mouseenter', function() {
			setVisibility(item, items, groups, true);
		});
  });

	subitems.forEach(function(item) {
		item.addEventListener('mouseenter', function() {
			setVisibility(item, subitems, ctas, false, 'subitem', 'cta');
		});
	});
});


var navTrigger = document.querySelector('.js-drawer-open-nav');
var navMobile = document.querySelector('[data-nav-mobile]');

if ( navMobile && navTrigger ) {
  var submenuTriggers = navMobile.querySelectorAll('[data-trigger]')
	var submenuCloseTriggers = navMobile.querySelectorAll('[data-close-submenu]')

  navTrigger.addEventListener('click', function(e) {
    e.preventDefault();
    navMobile.classList.toggle('is-open');
    document.body.classList.toggle('nav-is-open');
    document.body.classList.toggle('nav-expanded');
    // document.documentElement.classList.toggle('js-drawer-open');
  });

	submenuTriggers.forEach(function(trigger) {
		trigger.addEventListener('click', function(e) {
			e.preventDefault()

			trigger.parentNode.classList.toggle('is-toggled')
		});
	});

  submenuCloseTriggers.forEach(function(item) {
    item.addEventListener('click', function(e) {
      e.preventDefault()

      var submenu = this.closest('[data-submenu]');
      submenu.parentNode.classList.remove('is-toggled');
    });
  });
}


/**
 * Collection description toggles
 */

var readmore = document.querySelectorAll('[data-readmore]')

if ( readmore ) {
  readmore.forEach(function(item) {
    var trigger = item.querySelector('[data-readmore-trigger]')
    var content = item.querySelector('[data-readmore-content]')

    if ( trigger && content ) {
      trigger.addEventListener('click', function(e) {
        e.preventDefault();

        item.classList.toggle('is-open')
        content.style.height = item.classList.contains('is-open') ? content.scrollHeight + 'px' : 0
      })
    }
  })
}

/**
 * Image bank
 */
(function(){
	var form = document.querySelector('.image-bank__password-form');

	if (form) {
		var response = form.querySelector('.js-response');
		var password = form.dataset.password;
		var passwordField = form.querySelector('input[type="password"]');

		form.addEventListener('submit', function (event) {
			event.preventDefault();

			if (password === passwordField.value) {
				Cookies.set('image-bank', 'granted');

				response.hidden = true;

				location.href = form.dataset.redirect;
			} else {
				response.hidden = false;
			}
		});
	}

	var imageBank = document.querySelector('[data-protected="image-bank"]');

	if (imageBank) {
		if (Cookies.get('image-bank') !== 'granted') {
			if (imageBank.dataset.redirect) {
				location.href = imageBank.dataset.redirect;
			}
		}
	}

	var menuButton = document.querySelector('.image-bank__menu button');

	if (menuButton) {
		var content = menuButton.parentElement.querySelector('.js-content');

		menuButton.addEventListener('click', function (event) {
			event.preventDefault();

			content.hidden = !content.hidden;
		});
	}
})();


document.addEventListener('DOMContentLoaded', function() {

	function checkFifty(el) {
    var rect = el.getBoundingClientRect();

    return (
        rect.top + (rect.height/2) > 0 && // top
        rect.left + (rect.width/2) > 0 && // left
        rect.top + (rect.height/2) < (window.innerHeight || document.documentElement.clientHeight) && // bottom
        rect.left + (rect.width/2) < (window.innerWidth || document.documentElement.clientWidth) // right
    );
  }

	var scrollLayout = document.querySelector('[data-scroll]')

	if ( scrollLayout ) {
		var sections = scrollLayout.querySelectorAll('[data-scroll-section]')
		var anchors = scrollLayout.querySelectorAll('[data-scroll-anchor]')

		scrollLayout.addEventListener('scroll', function(event) {
			sections.forEach(function(item) {
				var inViewport = checkFifty(item)

				if ( inViewport ) {
					var id = item.id
					var { bg, color, linkColor, activeColor } = item.dataset

					scrollLayout.style.setProperty('--bgColor', bg)
					scrollLayout.style.setProperty('--textColor', color)
					scrollLayout.style.setProperty('--linkColor', linkColor)
					scrollLayout.style.setProperty('--activeColor', activeColor)

					// Set active anchor
					anchors.forEach(function(anchor) {
						if ( anchor.dataset.scrollAnchor === id ) anchor.classList.add('is-active')
						else anchor.classList.remove('is-active')
					})

				}

			})
		})
	}



	/**
	 * Scroll indicator
	 */

	var heroScroll = document.querySelector('[data-hero-meta]')
	if ( heroScroll ) {
		var top = heroScroll.getBoundingClientRect().top

		heroScroll.addEventListener('click', function(e) {
			e.preventDefault();
			window.scrollTo(0, top + heroScroll.offsetHeight)
		})

		window.addEventListener('scroll', function(event) {
			var styles = window.getComputedStyle(document.documentElement)
			var header = Number(styles.getPropertyValue('--headerHeight').replace('px', ''))
			var usp = Number(styles.getPropertyValue('--uspbar').replace('px', ''))

			var heroPos = heroScroll.getBoundingClientRect().bottom - header - usp
			var opacity = heroPos / top * 100

			heroScroll.style.opacity = opacity + '%'
		})
	}

  // var productImage = document.querySelectorAll('.grid-product__image-mask');
  // var environmentImage = document.querySelector('.collection__usp-image');
  // if ( productImage.length && environmentImage ) {
  //   var productImageHeight = productImage[1].clientHeight;
  //   environmentImage.style.height = productImageHeight + 'px';
  // }

})

var countryTrigger = document.querySelectorAll('[data-trigger-country]');
countryTrigger.forEach(function(item) {
  item.addEventListener('click', function() {
    item.parentNode.classList.toggle('is-expanded');
  });
})


/**
 * CUSTOM SELECT BOXES
 * used for lang select
 */
;(function(){
  var selectBoxes = Array.from(document.querySelectorAll('[data-select]'));

  if ( selectBoxes.length ) {
    for (const selectBox of selectBoxes) {
      const selected = selectBox.querySelector('.selected');
      const optionsContainer = selectBox.querySelector('.options-container');
      const optionsList = selectBox.querySelectorAll('.option');

      selected.addEventListener('click', function() {
        optionsContainer.classList.toggle('active');
      });

      optionsList.forEach(function(option) {
        option.addEventListener('click', function() {
          selected.innerHTML = option.querySelector('label').innerHTML;
          optionsContainer.classList.remove('active');
        });
      });

      document.addEventListener('click', function(e) {
        if ( !selectBox.contains(e.target) ) {
          optionsContainer.classList.remove('active');
        }
      });
    }
  }
})();


/**
 * Product grid items
 */

var initGridForms = function() {
  var gridItemForms = document.querySelectorAll('[data-product-grid-form]');

  gridItemForms.forEach(function(form) {
    new theme.AjaxProduct(form, 'button[type="submit"]');
  });
}

initGridForms();

document.addEventListener('filter:completed', function() {
  initGridForms();
});

/**
 * Color swatch
 */

var initSwatches = function() {
  var swatchesWrappers = document.querySelectorAll('[data-swatches-wrapper]');

  swatchesWrappers.forEach(function(wrapper) {
    var swatches = wrapper.querySelectorAll('[data-swatch]');
    var defaultSwatch = wrapper.querySelector('[data-swatch].is-active');

    swatches.forEach(function(swatch) {
      var parent = swatch.closest('[data-product-id]');
      var swatchImages = parent ? parent.querySelectorAll('[data-swatch-image]') : [];
      var swatchId = swatch.dataset.swatch;

      swatch.addEventListener('mouseover', function() {
        swatches.forEach(function(item) { item.classList.remove('is-active') });
        swatch.classList.add('is-active');

        if (swatchImages.length) {
          var match = Array.from(swatchImages).find((function(image) {
            return image.id === swatchId;
          }));

          if (match) {
            swatchImages.forEach(function(image) {
              image.classList.remove('is-visible');
            });

            match.classList.add('is-visible');
          }
        }
      });
    });

    wrapper.addEventListener('mouseleave', function() {
      var parent = wrapper.closest('[data-product-id]');

      if (parent) {
        var visibleImages = parent.querySelectorAll('[data-swatch-image].is-visible');

        visibleImages.forEach(function(image) {
          image.classList.remove('is-visible');
        });
      }

      swatches.forEach(function(item) { item.classList.remove('is-active') });
      defaultSwatch.classList.add('is-active');
    });
  });
}

initSwatches();

document.addEventListener('filter:completed', function() {
  initSwatches();
});


/**
 * Megamenu
 */

var header = document.querySelector('#HeaderWrapper');
var megamenuTriggers = document.querySelectorAll('[data-megamenu-trigger]');
var navExpanded = false;

megamenuTriggers.forEach(function(trigger) {
  trigger.addEventListener('mouseenter', function() {
    var relatedKey = trigger.dataset.megamenuTrigger;
    var megamenus = document.querySelectorAll('[data-megamenu]:not([data-megamenu="' + relatedKey + '"])');
    var menu = document.querySelector('[data-megamenu="' + relatedKey + '"]');

    megamenus.forEach(function(menu) {
      menu.classList.remove('is-visible');
    });

    if (menu) {
      menu.classList.add('is-visible');
      navExpanded = true;
    } else {
      navExpanded = false;
    }

    if (navExpanded) {
      document.body.classList.add('nav-expanded');
    } else {
      document.body.classList.remove('nav-expanded');
    }
  });
});

header.addEventListener('mouseleave', function() {
  var breakpoint = window.matchMedia('(min-width: 769px)');
  var megamenus = document.querySelectorAll('[data-megamenu]');

  if (!breakpoint.matches) return;

  megamenus.forEach(function(menu) {
    menu.classList.remove('is-visible');
  });

  document.body.classList.remove('nav-expanded');
});


/**
 * Filter drawer
 */

var siteHeader = document.querySelector('#SiteHeader');
var headerIsLight = false;

document.addEventListener('drawerOpen.FilterDrawer', function() {
  headerIsLight = header.classList.contains('is-light');
  header.classList.remove('is-light');
  document.documentElement.classList.add('filter-open');

  siteHeader.classList.add('site-header--stuck');
  siteHeader.classList.add('site-header--opening');
});

document.addEventListener('drawerClose.FilterDrawer', function() {
  document.documentElement.classList.remove('filter-open');

  if (headerIsLight) {
    header.classList.add('is-light');
  }

  siteHeader.classList.remove('site-header--stuck');
  siteHeader.classList.remove('site-header--opening');
})


/**
 * Free cart gift
 */

function addItemById(formData, callback) {
  return fetch('/cart/add.js', {
    method: 'POST',
    credentials: 'same-origin',
    headers: {
      'Content-Type': 'application/json',
      'X-Requested-With': 'XMLHttpRequest',
    },
    body: JSON.stringify(formData),
  })
    .then((r) => r.json())
    .then((response) => {
      if (response.status === 422) {
        // eslint-disable-next-line no-alert
        alert(response.description);
      }
      return getCart(callback);
    });
}

function checkFreeProductQualification(cart) {
  if (theme.freeGift.product && typeof theme.freeGift.product === 'number' && (theme.freeGift.productCollection.length || theme.freeGift.productThreshold > 0) && !sessionStorage.getItem('dismissFreeGift')) {
    var items = cart.items;
    var freeProductIsInCart = items.some((x) => x.variant_id === theme.freeGift.product);
    var qualifiesForFreeProduct;

    if (theme.freeGift.productCollection.length) {
      qualifiesForFreeProduct = !freeProductIsInCart && items.length > 0 && items.some((x) => theme.freeGift.productCollection.includes(x.product_id))
    } else {
      var totalFiltered = items.reduce((accumulator, object) => accumulator + object.final_line_price, 0);
      qualifiesForFreeProduct = !freeProductIsInCart && items.length > 0 && totalFiltered >= theme.freeGift.productThreshold
    }

    if (qualifiesForFreeProduct) {
      addItemById({ id: theme.freeGift.product, quantity: 1 }, () => {
        document.dispatchEvent(new CustomEvent('cart:build'));
      })
    }
  }
}

document.addEventListener('cart:updated', (evt) => {
  var cart = evt.detail.cart;
  checkFreeProductQualification(cart);
})

document.addEventListener('cart:quantity', (event) => {
  const cartItemKey = +event.detail[0].split(':')[0];
  const qty = +event.detail[1];
  if (cartItemKey === theme.freeGift.product && qty === 0) {
    sessionStorage.setItem('dismissFreeGift', 'true');
  }
})

checkFreeProductQualification(theme.initialCart);
